import _ from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import { Form, Icon, Label } from "semantic-ui-react";
import { gEnums } from '../../../enums/globalEnums';
import { FormItemContext } from '../FormItem';

/**
 * 
 * @param {object} props (fip, selectMulti, itemProp, optionList)
 * @returns Form.Dropdonw
 */
const DropdownInput = (props) => {

  const formItemContext = useContext(FormItemContext)
  const { formItem_state } = formItemContext ?? {}
  const { fip, itemProp } = formItem_state ?? {}

  const _fip = props.fip || fip || {}

  const { selectMulti, optionList } = props ?? {}
  const { data } = itemProp ?? {}
  const { formItemType, fullRow } = data ?? {}

  if (_fip && (!_fip?.value || _fip?.value === '' || _fip?.value === undefined || _fip?.value === 'undefined')) { delete _fip.value }

  // if (_.isArray(_fip?.value)) {
  //   const nvs = []
  //   _fip.value.forEach(fv => {
  //     const vn = parseInt(_fip.value)
  //     if (vn && _.isNumber(vn)) {
  //       nvs.push(vn)
  //     } else {
  //       nvs.push(_fip.value)
  //     }
  //   })
  // }

  const [ddOptions, setDdOptions] = useState([])

  useEffect(() => {
    switch (formItemType) {
      case gEnums.formItemTypes.dropdownAdd:
        setDdOptions(_fip?.value || [])
        break;
      default:
        setDdOptions(optionList || [])
        break;
    }
    // eslint-disable-next-line
  }, [optionList]);

  const handleAddition = (e, { value }) => {
    const opts = [...ddOptions]
    const newOpts = [{ text: value, value }, ...opts]
    setDdOptions(newOpts)
    const x = {
      propname: _fip.propname,
      value: newOpts,
    }
    _fip.onChange(e, x)
  }

  if (fullRow) { _fip.className += ' full-row' }

  const _multiple = selectMulti || formItemType === gEnums.formItemTypes.dropdownAdd

  if (_multiple && _fip && (_fip?.value && !_.isArray(_fip?.value))) { _fip.value = [_fip.value] }

  const { key, propname } = _fip ?? {}
  delete _fip.key

  // HOLIDAY
  // All of our Mixtiles are 0.75 inches thick (just under 2 cm)

  // return <div style={{ width: '100%' }}>
  //   <div style={{ padding: '.75em 0' }}>{_.startCase(propname)}</div>
  //   <div style={{ width: '100%' }}>
  //     <Label style={{ width: '100%', padding: '1em 0 1em 1em', border: '1px solid var(--off-black-4' }}>{`${_.size(ddOptions)} Items`} <Icon name='arrow right' color='blue' style={{ float: 'right' }} /></Label>
  //   </div>
  // </div>

  return <Form.Dropdown
    className='swiper-no-swiping'
    key={propname}
    {..._fip}
    options={ddOptions && _.isArray(ddOptions) ? ddOptions : []}
    fluid
    search
    selection
    multiple={_multiple}
    allowAdditions={formItemType === gEnums.formItemTypes.dropdownAdd ? true : false}
    onAddItem={formItemType === gEnums.formItemTypes.dropdownAdd ? handleAddition : null}
  />
}

export const dropdown = (fip, options, selectMulti, itemProp) => {

  if (!options) { options = [] }
  if (!fip.value || fip.value === '' || fip.value === undefined || fip.value === 'undefined') { delete fip.value }

  if (_.isArray(fip.value)) {
    const nvs = []
    fip.value.forEach(fv => {
      const vn = parseInt(fip.value)
      if (vn && _.isNumber(vn)) {
        nvs.push(vn)
      } else {
        nvs.push(fip.value)
      }
    })
  }

  const { data, formItemType } = itemProp ?? {}

  if (data && data.fullRow) { fip.className += ' full-row' }

  if (selectMulti && fip.value && !_.isArray(fip.value)) { fip.value = [fip.value] }

  return <Form.Dropdown
    className='swiper-no-swiping'
    {...fip}
    options={options}
    fluid
    search
    selection
    multiple={selectMulti}
    allowAdditions={formItemType === gEnums.formItemTypes.dropdownAdd}
  />
}

export default DropdownInput